export const PRIVILEGE_REQUIRED_MODULES = ['ingo', 'ingo-new', 'guardian', 'oranta', 'inter-polis'];
